module.exports = __webpack_public_path__ + "static/img/LeftBanner.4155ce8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banners/LeftBanner.jpg
// module id = tu8l
// module chunks = 1